import React, { useCallback, useState, useRef } from 'react'

import { GetCard } from '@web/walter-lib/api'
import { SettingsTabs } from '../../types'
import Code from './views/Code/Code'
import Success from './views/Success/Success'
import Confirmation from '~components/ConfirmationModal/Confirmation'
import { usePromise } from '~hooks/usePromise'
import { cardsApi } from '~api'
import { processPermissionError } from '~utils/processPermissionError'

interface Props {
    onClose: () => void
    setTab: (tab: SettingsTabs) => void
    tab: SettingsTabs
    card?: GetCard
}

function Pin({ onClose, tab, setTab, card }: Props) {
    const [confirmModal, setConfirmModal] = useState({ showTwoFa: false, showVerificationCode: false })
    const pinRef = useRef('')

    const { send: sendPin, isLoading } = usePromise(async () => {
        try {
            await cardsApi.cardPin({
                id: card?.id || '',
                pin: pinRef.current,
            })

            setTab(SettingsTabs.pinSuccess)
        } catch (error) {
            const { showVerificationCode, showTwoFa } = processPermissionError(error)

            if (showVerificationCode || showTwoFa) {
                setConfirmModal({ showTwoFa, showVerificationCode })
                setTab(SettingsTabs.pinTwoFa)
                return
            }

            throw error
        }
    })

    const onContinue = useCallback(
        (pin: string) => {
            pinRef.current = pin
            sendPin()
        },
        [sendPin]
    )

    return (
        <>
            {tab === 'pinCode' && <Code onClose={onClose} onContinue={onContinue} isLoading={isLoading} />}
            {tab === 'pinTwoFa' && (
                <Confirmation
                    initialInputState="pending"
                    onSuccess={sendPin}
                    showTwoFa={confirmModal?.showTwoFa || false}
                    showVerificationCode={confirmModal?.showVerificationCode || false}
                    resource={cardsApi.resources.pin(card?.id || '')}
                    isLoading={isLoading}
                />
            )}
            {tab === 'pinSuccess' && <Success onClose={onClose} />}
        </>
    )
}

export default Pin
